import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks/use-pagination-query";
import { http } from "../../../utils/http";

function fetchProductInquiryList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/product-inquiry", baseUrl);

  if (params.hospitalName) {
    endpointUrl.searchParams.append("hospitalName", params.hospitalName);
  }

  if (params.hospitalMemberEmail) {
    endpointUrl.searchParams.append(
      "hospitalMemberEmail",
      params.hospitalMemberEmail
    );
  }

  if (params.productName) {
    endpointUrl.searchParams.append("productName", params.productName);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useProductInquiryList(params = {}) {
  return usePaginationQuery(
    [
      "product-inquiry",
      params.hospitalName,
      params.hospitalMemberEmail,
      params.productName,
      params.from,
      params.to,
      params.status,
    ],
    (paginationState) =>
      fetchProductInquiryList({ ...params, ...paginationState })
  );
}
async function addProductInquiry(formData) {
  const data = await http(`/admin/product-inquiry`, {
    data: formData,
  });
  return data;
}

export function useAddProductInquiry() {
  const queryClient = useQueryClient();

  return useMutation(addProductInquiry, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-inquiry"]);
    },
  });
}

export function useUpdateProductInquiry() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/product-inquiry/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(["product-inquiry"]);
        setTimeout(() => {
          navigate("/bulletin-board/");
        }, 1500);
      },
    }
  );
}

async function deleteProductInquiry(id) {
  const data = await http(`/admin/product-inquiry/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteProductInquiry() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteProductInquiry, {
    onSuccess: () => {
      queryClient.invalidateQueries(["product-inquiry"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchProductInquiryDownload() {
  const { data } = await http(`/admin/product-inquiry-download`, {
    responseType: "blob",
  });

  return data;
}

export function useProductInquiryDownload() {
  const { data, ...raResult } = useQuery(["product-inquiry-download"], () =>
    fetchProductInquiryDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
